export default __webpack_public_path__ + "static/media/no_image.ee97e8e7.svg";